"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "bg-white p-5 mb-4"
};
const _hoisted_2 = { class: "uppercase font-bold text-xl border-b-1 border-gray pb-3" };
const _hoisted_3 = { class: "flex flex-col md:flex-row" };
const _hoisted_4 = { class: "flex items-start w-full md:w-1/2 py-2 md:pr-3.5" };
const _hoisted_5 = { class: "w-56 text-base" };
const _hoisted_6 = { class: "grow mr-2 text-base text-right" };
const _hoisted_7 = { class: "flex items-start w-full md:w-1/2 py-2 md:pl-3.5" };
const _hoisted_8 = { class: "w-56 text-base" };
const _hoisted_9 = { class: "grow mr-2 text-base text-right" };
const _hoisted_10 = { class: "flex flex-col md:flex-row" };
const _hoisted_11 = { class: "flex items-start w-full md:w-1/2 py-2 md:pr-3.5" };
const _hoisted_12 = { class: "w-56 text-base" };
const _hoisted_13 = { class: "grow mr-2 text-base text-right" };
const _hoisted_14 = { class: "flex items-start w-full md:w-1/2 py-2 md:pl-3.5" };
const _hoisted_15 = { class: "w-56 text-base" };
const _hoisted_16 = { class: "grow mr-2 text-base text-right" };
const _hoisted_17 = { class: "flex flex-col md:flex-row" };
const _hoisted_18 = { class: "flex items-start w-full md:w-1/2 py-2 md:pr-3.5" };
const _hoisted_19 = { class: "w-56 text-base" };
const _hoisted_20 = { class: "grow mr-2 text-base text-right" };
const _hoisted_21 = { class: "flex items-start w-full md:w-1/2 py-2 md:pl-3.5" };
const _hoisted_22 = { class: "w-56 text-base" };
const _hoisted_23 = { class: "grow mr-2 text-base text-right" };
const _hoisted_24 = { class: "flex flex-col md:flex-row" };
const _hoisted_25 = { class: "flex items-start w-full md:w-1/2 py-2 md:pr-3.5" };
const _hoisted_26 = { class: "w-56 text-base" };
const _hoisted_27 = { class: "grow mr-2 text-base text-right" };
const _hoisted_28 = { class: "flex items-start w-full md:w-1/2 py-2 md:pl-3.5" };
const _hoisted_29 = { class: "w-56 text-base" };
const _hoisted_30 = { class: "grow mr-2 text-base text-right" };
const _hoisted_31 = { class: "flex flex-col md:flex-row" };
const _hoisted_32 = { class: "flex items-start w-full md:w-1/2 py-2 md:pr-3.5" };
const _hoisted_33 = { class: "w-full text-base pt-3" };
const _hoisted_34 = { class: "inline-flex items-start mr-2 pt-3" };
const _hoisted_35 = { class: "flex items-center" };
const _hoisted_36 = { class: "inline font-bold uppercase text-base mr-2" };
const _hoisted_37 = { class: "inline font-bold uppercase text-base" };
const _hoisted_38 = { class: "flex items-start w-full md:w-1/2 py-2 md:pl-3.5" };
const _hoisted_39 = { class: "w-56 text-base pt-3" };
const _hoisted_40 = { class: "flex flex-col md:flex-row" };
const _hoisted_41 = { class: "flex items-start w-full md:w-1/2 py-2 md:pr-3.5" };
const _hoisted_42 = { class: "w-56 text-base pt-3" };
const _hoisted_43 = { class: "flex items-start w-full md:w-1/2 py-2 md:pl-3.5" };
const _hoisted_44 = { class: "w-56 text-base pt-3" };
const ShopInput_vue_1 = __importDefault(require("../../components/Form/ShopInput.vue"));
const Toggle_vue_1 = __importDefault(require("../../components/Form/Toggle.vue"));
const securityStore_1 = require("../../stores/security/securityStore");
const i18n_1 = require("../../common/i18n");
exports.default = (0, vue_1.defineComponent)({
    __name: 'CustomerDataForm',
    props: {
        guaranteeProductReturnCreateRequest: {
            type: Object,
        },
    },
    setup(__props) {
        const props = __props;
        const securityStore = (0, securityStore_1.useSecurityStore)();
        return (_ctx, _cache) => {
            return ((0, vue_2.unref)(securityStore).authenticatedUser !== null &&
                __props.guaranteeProductReturnCreateRequest !== undefined)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("customer_data", "Customer Data", "guarantee_product_return")), 1),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createElementVNode)("div", _hoisted_5, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("customer_id", "Customer id", "guarantee_product_return")), 1),
                            (0, vue_2.createElementVNode)("div", _hoisted_6, (0, vue_2.toDisplayString)((0, vue_2.unref)(securityStore).authenticatedUser
                                .customer.id), 1)
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_7, [
                            (0, vue_2.createElementVNode)("div", _hoisted_8, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("customer_name", "Customer name", "guarantee_product_return")), 1),
                            (0, vue_2.createElementVNode)("div", _hoisted_9, (0, vue_2.toDisplayString)((0, vue_2.unref)(securityStore).authenticatedUser
                                .customer.name), 1)
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_10, [
                        (0, vue_2.createElementVNode)("div", _hoisted_11, [
                            (0, vue_2.createElementVNode)("div", _hoisted_12, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("customer_zip", "Zip code", "guarantee_product_return")), 1),
                            (0, vue_2.createElementVNode)("div", _hoisted_13, (0, vue_2.toDisplayString)((0, vue_2.unref)(securityStore).authenticatedUser
                                .customer.zipCode), 1)
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_14, [
                            (0, vue_2.createElementVNode)("div", _hoisted_15, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("customer_city", "City", "guarantee_product_return")), 1),
                            (0, vue_2.createElementVNode)("div", _hoisted_16, (0, vue_2.toDisplayString)((0, vue_2.unref)(securityStore).authenticatedUser
                                .customer.city), 1)
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_17, [
                        (0, vue_2.createElementVNode)("div", _hoisted_18, [
                            (0, vue_2.createElementVNode)("div", _hoisted_19, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("customer_street", "Street", "guarantee_product_return")), 1),
                            (0, vue_2.createElementVNode)("div", _hoisted_20, (0, vue_2.toDisplayString)((0, vue_2.unref)(securityStore).authenticatedUser
                                .customer.street), 1)
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_21, [
                            (0, vue_2.createElementVNode)("div", _hoisted_22, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("customer_phone", "Phone", "guarantee_product_return")), 1),
                            (0, vue_2.createElementVNode)("div", _hoisted_23, (0, vue_2.toDisplayString)((0, vue_2.unref)(securityStore).authenticatedUser
                                .customer.phone), 1)
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_24, [
                        (0, vue_2.createElementVNode)("div", _hoisted_25, [
                            (0, vue_2.createElementVNode)("div", _hoisted_26, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("customer_mobile", "Mobile", "guarantee_product_return")), 1),
                            (0, vue_2.createElementVNode)("div", _hoisted_27, (0, vue_2.toDisplayString)((0, vue_2.unref)(securityStore).authenticatedUser
                                .customer.mobile), 1)
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_28, [
                            (0, vue_2.createElementVNode)("div", _hoisted_29, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("customer_email", "Email", "guarantee_product_return")), 1),
                            (0, vue_2.createElementVNode)("div", _hoisted_30, (0, vue_2.toDisplayString)((0, vue_2.unref)(securityStore).authenticatedUser
                                .customer.email), 1)
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_31, [
                        (0, vue_2.createElementVNode)("div", _hoisted_32, [
                            (0, vue_2.createElementVNode)("div", _hoisted_33, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("customer_equals_end_user", "Customer equals end user", "guarantee_product_return")), 1),
                            (0, vue_2.createElementVNode)("div", _hoisted_34, [
                                (0, vue_2.createElementVNode)("div", _hoisted_35, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_36, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("customer_equals_end_user_no", "No", "guarantee_product_return")), 1),
                                    (0, vue_2.createVNode)(Toggle_vue_1.default, {
                                        modelValue: __props.guaranteeProductReturnCreateRequest.customerEqualsEndUser,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((__props.guaranteeProductReturnCreateRequest.customerEqualsEndUser) = $event)),
                                        class: "mx-3"
                                    }, null, 8, ["modelValue"]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_37, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("customer_equals_end_user_yes", "Yes", "guarantee_product_return")), 1)
                                ])
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_38, [
                            (0, vue_2.createElementVNode)("div", _hoisted_39, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("complaint_date", "Complaint date", "guarantee_product_return")), 1),
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                class: "!w-fit !grow",
                                border: "",
                                type: "date",
                                "show-validity": true,
                                valid: __props.guaranteeProductReturnCreateRequest.isComplaintDateValid(),
                                "invalid-message": (0, vue_2.unref)(i18n_1.trans)('complaint_date_required', 'Complaint date required', 'guarantee_product_return'),
                                required: "",
                                max: "9999-12-31",
                                modelValue: __props.guaranteeProductReturnCreateRequest.complaintDate,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((__props.guaranteeProductReturnCreateRequest.complaintDate) = $event))
                            }, null, 8, ["valid", "invalid-message", "modelValue"])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_40, [
                        (0, vue_2.createElementVNode)("div", _hoisted_41, [
                            (0, vue_2.createElementVNode)("div", _hoisted_42, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("complainant_name", "Complainant name", "guarantee_product_return")), 1),
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                class: "!w-fit !grow",
                                border: "",
                                "show-validity": true,
                                valid: __props.guaranteeProductReturnCreateRequest.isComplainantNameValid(),
                                "invalid-message": (0, vue_2.unref)(i18n_1.trans)('complaint_name_required', 'Complaint name required', 'guarantee_product_return'),
                                required: "",
                                modelValue: __props.guaranteeProductReturnCreateRequest.complainantName,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((__props.guaranteeProductReturnCreateRequest.complainantName) = $event))
                            }, null, 8, ["valid", "invalid-message", "modelValue"])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_43, [
                            (0, vue_2.createElementVNode)("div", _hoisted_44, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("guarantee_card_number", "Guarantee card number", "guarantee_product_return")), 1),
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                class: "!w-fit !grow",
                                border: "",
                                "show-validity": true,
                                valid: true,
                                required: "",
                                modelValue: __props.guaranteeProductReturnCreateRequest.guaranteeCardNumber,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((__props.guaranteeProductReturnCreateRequest.guaranteeCardNumber) = $event))
                            }, null, 8, ["modelValue"])
                        ])
                    ])
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
